import { Link } from 'react-router-dom';
import { Check, Star, ArrowRight } from 'lucide-react';
import { PRO, PRO_MAX } from '../../config/pricing';
import { SectionHeader, Cta } from '../common';
import { CHECKOUT, openExternal } from '../../config/links';

function Card({ plan, featured, event, delay = 0 }) {
  const monthly = plan.plans[0];
  return (
    <div className="panel p-8 reveal reveal-card flex flex-col" style={{
      transitionDelay: `${delay}ms`,
      borderColor: featured ? 'var(--gold-border)' : 'var(--border)',
      background: featured ? 'linear-gradient(180deg, rgba(214,179,106,0.07), var(--surface) 42%)' : 'var(--surface)',
      boxShadow: featured ? '0 24px 70px rgba(214,179,106,0.10)' : 'none',
    }}>
      <div className="flex items-center justify-between">
        <h3 className="font-display text-[22px] font-bold text-white">{plan.name}</h3>
        {featured && <span className="tag"><Star size={12} /> Most Power</span>}
      </div>
      <p className="mt-2 text-[14px] text-[var(--muted)]">{plan.tagline}</p>
      <div className="mt-6 flex items-end gap-2">
        <span className="font-display text-[44px] font-bold text-white leading-none">{monthly.price}</span>
        <span className="font-mono text-[13px] text-[var(--muted-2)] pb-1.5">/mo</span>
      </div>
      <div className="chip mt-3 w-fit" style={{ color: 'var(--gold-2)', borderColor: 'var(--gold-border)' }}>{plan.credits}</div>
      <div className="gold-divider my-6" />
      <ul className="flex flex-col gap-3.5 flex-1">
        {plan.features.map((f) => (
          <li key={f} className="flex items-start gap-2.5 text-[14px] text-[var(--muted)]"><Check size={16} className="text-[var(--gold-2)] shrink-0 mt-0.5" />{f}</li>
        ))}
      </ul>
      <div className="mt-7 flex flex-col gap-2.5">
        <Cta variant={featured ? 'gold' : 'outline'} href={CHECKOUT[plan.checkout.stripe]} onClick={() => openExternal(CHECKOUT[plan.checkout.stripe], event)}>Get {plan.name}</Cta>
        <Link to="/pricing" className="text-center text-[13px] text-[var(--muted)] hover:text-[var(--gold-3)] transition-colors">See all plans &amp; billing</Link>
      </div>
    </div>
  );
}

export default function PricingPreview() {
  return (
    <section className="section">
      <div className="container-x">
        <div className="reveal"><SectionHeader center eyebrow="Pricing" title="Choose your level of intelligence." sub="Flexible monthly, quarterly and annual billing in USD. Pay by card or crypto. Cancel anytime." /></div>
        <div className="grid md:grid-cols-2 gap-5 mt-14 max-w-[880px] mx-auto">
          <Card plan={PRO} event="pro_checkout_click" delay={0} />
          <Card plan={PRO_MAX} featured event="pro_max_checkout_click" delay={120} />
        </div>
        <div className="text-center mt-10 reveal">
          <Link to="/pricing" className="inline-flex items-center gap-1.5 text-[14px] text-[var(--gold-3)] hover:gap-2.5 transition-all">View full pricing, exchange tiers &amp; Kalki Credits <ArrowRight size={15} /></Link>
        </div>
      </div>
    </section>
  );
}
